// extracted by mini-css-extract-plugin
export default {"surgery-list-box":"SurgeryMore_surgery-list-box__O5JUt","span-box":"SurgeryMore_span-box__UArMX"};